<template lang="pug">
  div
    .role-label(v-if='isSuperUser') SuperAdmin

    .selected-label(v-if='!isSuperUser && !showDropdown')
      | {{ activeCompany.name }} &nbsp;

    el-popover(v-if='!isSuperUser && showDropdown' ref='companiesPopover' placement="bottom" width="200" trigger="click" :visible-arrow='false')
      .selected-label(slot="reference")
        | {{ activeCompany.name }} &nbsp;
        icon(name="caret-down")

      h3 Switch company:
      .company-list
        .company-item(v-for='company in userCompanyList' :key='company.id' @click='switchCompany(company.id)')
          | {{ company.name }}

    el-popover(v-if='isSuperUser' placement="bottom" ref='companiesPopover' width="200" trigger="click" :visible-arrow='false' @show='loadCompanies')
      .selected-label(slot="reference")
        | {{ activeCompany ? activeCompany.name : 'Select a company' }} &nbsp;
        icon(name="caret-down")

      h3 View as:
      .company-list
        .company-item(v-for='company in superUsercompanyList' :key='company.id' @click='logInAsCompany(company.id)')
          | {{ company.name }}

</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      loadingCompanies: false,
      companies: []
    };
  },
  computed: {
    ...mapGetters({
      userCompanies: "auth/userCompanies",
      isSuperUser: "auth/isSuperUser",
      activeCompany: "auth/activeCompany"
    }),
    showDropdown() {
      return this.userCompanies.length >= 2;
    },
    userCompanyList() {
      if (!this.activeCompany) {
        return _.orderBy(this.companies, "name");
      }
      return _.orderBy(
        this.userCompanies.filter(c => c.id !== this.activeCompany.id),
        uc => uc.company.name
      );
    },
    superUsercompanyList() {
      if (!this.activeCompany) {
        return this.companies;
      }
      return _.orderBy(
        this.companies.filter(c => c.id !== this.activeCompany.id),
        "name"
      );
    }
  },
  methods: {
    ...mapActions({
      fetchCompanies: "companies/fetchCompanies",
      viewAsCompany: "auth/viewAsCompany"
    }),
    ...mapMutations("ui", ["toggleRightSidenav"]),
    ...mapMutations({
      setActiveCompany: "auth/setActiveCompany"
    }),
    switchCompany(companyId) {
      this.viewAsCompany({ companyId }).then(() => {
        this.$refs.companiesPopover.doClose();
        this.$router.push({
          name: "brapp:dashboard",
          params: { app: "brapp" }
        });
        this.toggleRightSidenav();
      });
    },
    loadCompanies() {
      this.loadingCompanies = true;
      this.fetchCompanies().then(data => {
        this.companies = data;
        this.loadingCompanies = false;
      });
    },
    logInAsCompany(companyId) {
      this.viewAsCompany({ companyId }).then(() => {
        this.$refs.companiesPopover.doClose();
        this.$router.push({
          name: "brapp:dashboard",
          params: { app: "brapp" }
        });
        this.toggleRightSidenav();
      });
    }
  }
};
</script>

<style scoped lang="scss">
.selected-label {
  cursor: pointer;
  user-select: none;
  font-family: "gilroyextrabold";
}

.role-label {
  font-size: 13px;
}

.company-item {
  margin-bottom: 5px;
}

.app-item {
  margin-bottom: 10px;
}

.group-item {
  margin-bottom: 10px;
  cursor: pointer;
  &:hover {
    background: #eee;
  }
}

.app-list {
  margin-left: 10px;
  margin-top: 10px;
}

.group-list {
  margin-left: 10px;
  margin-top: 10px;
}

.company-list {
  max-height: 250px;
  overflow-y: auto;
}

.company-item {
  font-size: 14px;
  padding: 10px;
  border-bottom: 1px solid #eee;
  cursor: pointer;

  &:hover {
    background: #eee;
  }

  &:last-child {
    border-bottom: 0;
  }
}
</style>
